export const defaultLocale = {
  flag: "🇫🇷",
  id: 0,
  iso_code: "fr_FR",
  iso_code_639: "fr-FR",
  label: "language_french",
  language_key: "language.fr_fr",
  localized_language_key: "language.localized.fr_fr",
}

export const i18nNamespaces = [
  "general",
  "accessibility",
  "assessment",
  "candidate_account",
  "language",
  "data_jobs",
  "swipe",
  "shape",
  "drive",
  "brain",
  "move",
  "movebis",
  "onboarding",
  "pole_emploi",
  "profile",
  "error",
  "voice",
  "skills",
  "language",
  "scan",
  "register_guest",
  "navigation",
]
